export default __webpack_public_path__ + "img/WJIfElYV.762e1b4f.svg";